import moment from 'moment';

import { GranulationTypeId } from 'webapp/enums/enums';

import type DChartPrimaryPoint from 'webapp/d-chart/point/primary-point';

export const getAnomalyVariant = (
	pointData: DChartPrimaryPoint,
	anomalyPoint: DChartPrimaryPoint,
	isInverted: boolean,
) => {
	if (
		typeof pointData.value === 'number' &&
		typeof anomalyPoint.anomalyData?.upperValue === 'number' &&
		typeof anomalyPoint.anomalyData?.lowerValue === 'number'
	) {
		const isPositive = isInverted
			? pointData.value < anomalyPoint.anomalyData.lowerValue
			: pointData.value > anomalyPoint.anomalyData.upperValue;
		const value = anomalyPoint.value || 0;

		return getBaseAnomalyVariant(isPositive, value);
	}

	return {};
};

export interface AnomalyVariant {
	name: 'positive' | 'positive-significant' | 'negative' | 'negative-significant';
	bgColor: string;
	color: string;
	text: string;
}

export const getBaseAnomalyVariant = (isPositive: boolean, value: number): AnomalyVariant => {
	if (isPositive) {
		if (value < 0.8) {
			return {
				name: 'positive',
				bgColor: 'green-lime-alpha-10',
				color: 'green-lime-80',
				text: 'A positive deviation from the expected range has been detected.',
			};
		} else {
			return {
				name: 'positive-significant',
				bgColor: 'green-alpha-10',
				color: 'green-80',
				text: 'A significant positive deviation from the expected range has been detected.',
			};
		}
	} else {
		if (value < 0.8) {
			return {
				name: 'negative',
				bgColor: 'orange-alpha-10',
				color: 'orange-80',
				text: 'A negative deviation from the expected range has been detected.',
			};
		} else {
			return {
				name: 'negative-significant',
				bgColor: 'red-alpha-10',
				color: 'red-light',
				text: 'A significant negative deviation from the expected range has been detected.',
			};
		}
	}
};

export const getMaxTrainingPeriod = (granulationTypeId: GranulationTypeId) => {
	const today = moment();
	const twoYearsAgo = today.clone().subtract(2, 'years'); // Hardcoded number

	if (granulationTypeId === GranulationTypeId.HOURLY) {
		return { num: today.diff(twoYearsAgo, 'hours'), text: 'hours' };
	} else if (granulationTypeId === GranulationTypeId.DAILY) {
		return { num: today.diff(twoYearsAgo, 'days'), text: 'days' };
	} else if (granulationTypeId === GranulationTypeId.WEEKLY) {
		return { num: today.diff(twoYearsAgo, 'weeks'), text: 'weeks' };
	} else if (granulationTypeId === GranulationTypeId.MONTHLY) {
		return { num: today.diff(twoYearsAgo, 'months'), text: 'months' };
	} else if (granulationTypeId === GranulationTypeId.QUARTERLY) {
		return { num: today.diff(twoYearsAgo, 'quarters'), text: 'quarters' };
	} else if (granulationTypeId === GranulationTypeId.YEARLY) {
		return { num: today.diff(twoYearsAgo, 'years'), text: 'years' };
	} else {
		throw new Error('Granulation type not supported');
	}
};
